import React from 'react';
import "./utils.css";
import { Btn } from './utils';

const Pagination = ({pagData, clickNext, clickPrev}) => {
  
  return (
    <div className='pag'>
        <p>Showing {pagData?.currentPage} of {pagData?.numberOfPages} pages</p>
        <div className="pag-btn_cont">
            <Btn btnText={"Previous"} btnClass={"pag-btn"}  btnClick={clickPrev} disabled={pagData?.previousPage === null} />
            <Btn btnText={"Next"} btnClass={"pag-btn"} btnClick={clickNext} disabled={pagData?.nextPage === null} />
        </div>
    </div>
  )
}

export default Pagination